var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.498 21.474a1.665 1.665 0 0 1 0 2.355l-6.662 6.662a1.665 1.665 0 1 1-2.355-2.356l6.663-6.662a1.665 1.665 0 0 1 2.355 0zM13.993 1a9.993 9.993 0 1 1 0 19.986 9.993 9.993 0 0 1 0-19.986zm0 3.331a6.662 6.662 0 1 0 0 13.325 6.662 6.662 0 0 0 0-13.324v.001zm11.659-3.33a1.666 1.666 0 1 1 0 3.331 1.666 1.666 0 0 1 0-3.33z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrt);
export default __webpack_public_path__ + "static/media/GRT.8146f80124b1c59b20c6d87d7195803e.svg";
export { ForwardRef as ReactComponent };